import type { WidgetState } from "../types";

export class WidgetStateManager {
  private state: WidgetState;

  constructor() {
    this.state = {
      isOpen: false,
      isReady: false,
    };
  }

  getState(): Readonly<WidgetState> {
    return { ...this.state };
  }

  setIsOpen(isOpen: boolean): void {
    this.state = { ...this.state, isOpen };
  }

  setIsReady(isReady: boolean): void {
    this.state = { ...this.state, isReady };
  }

  setConversationId(conversationId: string | undefined): void {
    this.state = { ...this.state, conversationId };
  }

  isOpen(): boolean {
    return this.state.isOpen;
  }

  isReady(): boolean {
    return this.state.isReady;
  }

  getConversationId(): string | undefined {
    return this.state.conversationId;
  }

  reset(): void {
    this.state = {
      isOpen: false,
      isReady: false,
    };
  }
}
